module.exports = {
    setUserGoal: function(goal) {
       sessionStorage.setItem('goal', JSON.stringify(goal));
    //    sessionStorage.setItem('token', token);
    //    document.cookie = "user=" + JSON.stringify(user) + "; SameSite=None; Secure";

    },
    getUserGoal: function() {
        const goal = sessionStorage.getItem('goal');
        if (goal === 'undefined' || !goal) {
            return null;
        }
        else{
            return JSON.parse(goal)
        }
    },

    resetUserGoal: function() {
       sessionStorage.removeItem('goal')
    },
    
}